module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate-new/design-tile-images/design-tile-19-7c7696e8baba3dccdc34ccb26e204429.jpg";